import { render } from "./TeamPopup.vue?vue&type=template&id=05891bf8"
import script from "./TeamPopup.vue?vue&type=script&lang=js"
export * from "./TeamPopup.vue?vue&type=script&lang=js"

import "./TeamPopup.vue?vue&type=style&index=0&id=05891bf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__